// src/CometChat/CometChatListener.js

import { useEffect } from 'react';
import { CometChat } from "@cometchat/chat-sdk-javascript";
import { useSnackbar } from '../../../Components/SnackbarContext';

const CometChatListener = () => {
  const { triggerSnackbar } = useSnackbar();

  useEffect(() => {
    const listenerID = "chatMessageListener";

    CometChat.addMessageListener(
      listenerID,
      new CometChat.MessageListener({
        onTextMessageReceived: textMessage => {
          console.log("Text message received", textMessage);
          triggerSnackbar(
            textMessage,
            // `New message from ${textMessage.sender.name}: ${textMessage.text}`,
            5,
            { vertical: 'bottom', horizontal: 'right' },
            "CometChat"
          );
        },
        onMediaMessageReceived: mediaMessage => {
          console.log("Media message received", mediaMessage);
          triggerSnackbar(
            mediaMessage,
            // `New media message from ${mediaMessage.sender.name}`,
            5,
            { vertical: 'bottom', horizontal: 'right' },
            "CometChat"
          );
        },
        onCustomMessageReceived: customMessage => {
          console.log("Custom message received", customMessage);
          triggerSnackbar(
            customMessage,
            // "You've received a custom message.",
            5,
            { vertical: 'bottom', horizontal: 'right' },
            "CometChat"
          );
        }
      })
    );

    return () => {
      CometChat.removeMessageListener(listenerID);
    };
  }, [triggerSnackbar]);

  return null; // no UI
};

export default CometChatListener;
